import { Input, InputNumber } from "antd";

type InputMode =
  | "none"
  | "text"
  | "decimal"
  | "numeric"
  | "tel"
  | "search"
  | "email"
  | "url";

const _setInputMode = (inputMode: InputMode, input: HTMLInputElement) => {
  input.inputMode = inputMode;
};

export const setInputMode = (inputMode: InputMode) => (input: Input) => {
  // NOTE: なぜかnullがきたことがあったので、念の為nullチェックしてる
  if (!input) return;
  if (!input.input) return;
  _setInputMode(inputMode, input.input);
};

export const setInputModeForInputNumber = (inputMode: InputMode) => (
  input: InputNumber
) => {
  // NOTE: なぜかnullがきたことがあったので、念の為nullチェックしてる
  if (!input) return;
  // NOTE: ↓の属性がprivateになってしまっているため、型チェックを無視している。
  // @ts-ignore
  if (!input.inputNumberRef) return;
  // @ts-ignore
  if (!input.inputNumberRef.input) return;
  // @ts-ignore
  _setInputMode(inputMode, input.inputNumberRef.input);
};
